import { useEffect, useState } from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import { analyticsApi } from '../../api/admin.js';

export default function FinanceAnalytics() {
  const [data, setData] = useState(null);
  useEffect(() => { analyticsApi.finance().then(setData); }, []);
  if (!data) return <div className="muted">Loading…</div>;

  return (
    <section>
      <header className="page-header"><h1>Finance Analytics</h1></header>
      <div className="card">
        <h3>P&amp;L summary (last 6 months)</h3>
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={data.pl}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="revenue" fill="#16a34a" />
            <Bar dataKey="expenses" fill="#dc2626" />
            <Bar dataKey="net" fill="#2563eb" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="grid-2">
        <div className="card">
          <h3>Budget utilization (this year)</h3>
          {data.budgetUtilization.length === 0 ? (
            <div className="muted">No budgets configured.</div>
          ) : (
            <div className="bvsa">
              {data.budgetUtilization.map((b) => (
                <div key={b.department} className="bvsa-row">
                  <div className="bvsa-label">{b.department}</div>
                  <div className="bvsa-bars">
                    <div className="bvsa-bar bg-budget" style={{ width: `${Math.min(100, (Math.abs(b.budget) / Math.max(1, b.budget)) * 100)}%` }}>
                      <span>{Math.round(b.budget).toLocaleString()}</span>
                    </div>
                    <div className="bvsa-bar bg-actual" style={{ width: `${Math.min(100, (Math.abs(b.actual) / Math.max(1, b.budget)) * 100)}%`, background: b.rate > 100 ? '#dc2626' : '#2563eb' }}>
                      <span>{Math.round(b.actual).toLocaleString()} ({b.rate}%)</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="card">
          <h3>Aging — Receivables vs Payables</h3>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={[
              { bucket: 'Current', AR: data.aging.receivable.current, AP: data.aging.payable.current },
              { bucket: '1-30', AR: data.aging.receivable['1-30'], AP: data.aging.payable['1-30'] },
              { bucket: '31-60', AR: data.aging.receivable['31-60'], AP: data.aging.payable['31-60'] },
              { bucket: '61-90', AR: data.aging.receivable['61-90'], AP: data.aging.payable['61-90'] },
              { bucket: '90+', AR: data.aging.receivable['90+'], AP: data.aging.payable['90+'] },
            ]}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="bucket" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="AR" fill="#16a34a" />
              <Bar dataKey="AP" fill="#dc2626" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </section>
  );
}
